import React from 'react';
import { Store } from 'redux';
import createPresenter from './framework/presenter/createPresenter';
import createInventory from './framework/presenter/createInventory';

const App: React.FC<{ store: Store<any> }> = ({ store }) => {
  const Presenter = createPresenter(createInventory(), store);
  return (
    <React.Fragment>
      <Presenter />
    </React.Fragment>
  );
};

export default App;
